import { styled } from 'config/stitches.config'

export const StyledSlider = styled('div', {})
